import { getLoginUrl } from '@repo/auth';
import { createFileRoute } from '@tanstack/react-router';
import { v4 as uuidv4 } from 'uuid';
import { z } from 'zod';
import { PendingComponent } from '../pending-component';
const loginSearchSchema = z.object({
    redirect: z.string().optional(),
    error: z.string().optional()
});
export const Route = createFileRoute('/login')({
    validateSearch: loginSearchSchema,
    loaderDeps: (param)=>{
        let { search: { redirect, error } } = param;
        return {
            redirect,
            error
        };
    },
    loader: async (param)=>{
        let { deps: { redirect: redirectUrl } } = param;
        const state = uuidv4(); // OAuth state for CSRF protection
        try {
            // Store redirect URL for after callback
            if (redirectUrl) {
                sessionStorage.setItem('auth_redirect', redirectUrl);
            }
            // Get OAuth URL from auth service
            const loginUrl = await getLoginUrl(state);
            // Redirect to OAuth provider
            window.location.href = loginUrl;
            // Return pending promise (page is redirecting away)
            return new Promise(()=>{});
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (error) {
            throw new Response('Failed to initiate login. Please try again later.', {
                status: 401
            });
        }
    },
    pendingComponent: PendingComponent
});
